module.exports = __webpack_public_path__ + "img/dyh.635b1715.png";